<template>
  <v-container v-if="!containerInitLoading && contract" fluid class="pa-0" style="height: inherit">
    <!--
    <v-row no-gutters>
      <v-col>
        <h2>Invoicing graph</h2>
        last invoice date: {{ i18nFormatDate(contract.LastInvoiceDate) }} <br>
        total cost: {{ contract.TotalCost }} <br>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row no-gutters>
      <v-col>
        <v-card class="ma-3 pa-3" flat style="width: 350px;">
          <ContractStepper :current-state="state" @transition="handleTransition">
          </ContractStepper>
        </v-card>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    -->
    <v-row no-gutters align="stretch" style="height: inherit">
      <v-col class="pa-3">
        <h2>Customer</h2>
        <QTextField v-model="contract.Customer.OrganisationNumber"
          :label="$t('servicesystem.common_objects.customer.organization_number')" :externaledit="editMode"
          @FocusState="editMode ? null : edittrigger++">
        </QTextField>
        <QTextField :label="$t('servicesystem.common_objects.customer.credit_limit')"
          :value="contract.Customer.CreditLimit ? contract.Customer.CreditLimit : $t('servicesystem.common_objects.commonterms.none')"
          :suffix="contract.Customer.CreditLimitExceeded ? (' (' + contract.Customer.CreditLimitExceeded + ')') : null"
          :valuecolor="contract.Customer.CreditLimit ? (contract.Customer.CreditLimitExceeded ? 'error' : 'primary') : 'disabled'">
        </QTextField>
        <QSwitchInput v-model="contract.Customer.FreeFromVat"
          :label="$t('servicesystem.common_objects.customer.free_from_vat')" :externaledit="editMode"
          @FocusState="editMode ? null : edittrigger++">
        </QSwitchInput>

        <h5>Contact</h5>
        <ContactTemplate :Contact="contract.CustomerPerson" :loading="loading">
        </ContactTemplate>
      </v-col>

      <v-divider vertical style="z-index: 1;"></v-divider>
      
      <v-col>
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="contract"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <ContractEditContent :item="item" :editMode="editMode" :handleFocus="handleFocus">
            </ContractEditContent>
          </template>
        </EntityEditCard>
      </v-col>
    </v-row>
    <!--
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col>
        <h2>Detail summary</h2>
      </v-col>
    </v-row>
     -->
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import ContractEditContent from "@/views/contracts/ContractEditContent.vue";
import ContactTemplate from "@/components/Preview/Customer/ContactTemplate.vue";
//import ContractStepper from "./ContractStepper.vue";

export default {
  name: "ViewContractInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    ContractEditContent,
    ContactTemplate,
    //ContractStepper
  },
  mixins: [clientAPI],

  data() {
    return {
      editMode: false,
      state: 'Draft',
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.changeContract(dto)
        .then((response) => {
          this.contract = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    handleTransition(payload) {
      // e.g. show confirm dialog then update state
      console.log('Transition requested', payload.from, '→', payload.to);
      this.state = payload.to;
    }
  },

  computed: {
    contract: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    loading() {
      return this.containerLoading;
    },


  },

  watch: {},
};
</script>


<style lang='scss'></style>